import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, catchError, of } from 'rxjs';
import { HrAlertService, HrHttpService } from '../hr-http.service';
import {
  canAccessBudgetForm,
  canAccessHrmsBudgetReport,
  EMPTY_MRF_HRMS_PERMISSIONS,
  EMPLOYEE_WITHDRAWAL_NAV_ENABLED,
  MrfHrmsPermissions,
} from '../mrf-view-options';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss'],
})
export class SideBarComponent implements OnInit, OnDestroy {
  readonly showBudgetNav = true;
  readonly canAccessEmployeeWithdrawal = EMPLOYEE_WITHDRAWAL_NAV_ENABLED;
  canAccessBudgetForm = false;
  canAccessHrmsBudgetReport = false;
  private readonly subs = new Subscription();

  constructor(
    private hrHttp: HrHttpService,
    private hrAlert: HrAlertService
  ) {}

  ngOnInit(): void {
    this.applyPermissions(this.hrHttp.getMrfHrmsPermissions());
    this.subs.add(
      this.hrHttp.getUserRoles().pipe(catchError(() => of(null))).subscribe((roles) => {
        if (roles == null) {
          return;
        }
        this.applyPermissions(this.hrHttp.setMrfHrmsPermissionsFromResponse(roles));
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  onBudgetReportNav(event: MouseEvent): void {
    if (this.canAccessBudgetForm) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.hrAlert.show('No permission to access budget module.', 'Warning');
  }

  onHrmsBudgetReportNav(event: MouseEvent): void {
    if (this.canAccessHrmsBudgetReport) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.hrAlert.show('No permission to access budget report.', 'Warning');
  }

  onEmployeeWithdrawalNav(event: MouseEvent): void {
    if (this.canAccessEmployeeWithdrawal) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
  }

  private applyPermissions(permissions: MrfHrmsPermissions): void {
    const next = permissions ?? { ...EMPTY_MRF_HRMS_PERMISSIONS };
    this.canAccessBudgetForm = canAccessBudgetForm(next);
    this.canAccessHrmsBudgetReport = canAccessHrmsBudgetReport(next);
  }
}
